import React from 'react';
interface FilterBarProps {
  filters: {
    group: string;
    options: string[];
  }[];
  active: string[];
  onToggle: (option: string) => void;
}
export function FilterBar({
  filters,
  active,
  onToggle
}: FilterBarProps) {
  return <div className="border-y border-line bg-white" data-id="element-112" data-mp="1glapqk9qfvew">
      <div className="mx-auto max-w-shell px-6 py-7 lg:px-10" data-id="element-113" data-mp="1ll6uilq97qvi">
        <div className="flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-114" data-mp="1ljc9z8iwa0ry">
          {filters.map(group => <fieldset key={group.group} className="flex flex-wrap items-center gap-2" data-id="element-115" data-mp="16q0npwjc3o14">
              <legend className="sr-only" data-id="element-116" data-mp="1boakucomcypd">{group.group}</legend>
              <span className="label mr-1 text-muted/70" data-id="element-117" data-mp="xnzurbv4vo59">{group.group}</span>
              {group.options.map(option => {
            const on = active.includes(option);
            return <button key={option} type="button" aria-pressed={on} onClick={() => onToggle(option)} className={`rounded-full border px-3.5 py-1.5 text-[12.5px] font-500 transition-colors duration-150 ease-soft ${on ? 'border-ink bg-ink text-paper' : 'border-line bg-paper text-muted hover:border-olive hover:text-ink'}`} data-id="element-118" data-mp="2s2ai1fw2ya8x">
                    {option}
                  </button>;
          })}
            </fieldset>)}
        </div>
      </div>
    </div>;
}